import {
  CustomFieldSchema,
  CustomFieldType,
  MemberListFilterByOperator,
} from '@tribeplatform/gql-client/types'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

export const FieldOperatorPicker = ({
  field,
  onChange,
  value,
}: {
  field: CustomFieldSchema
  onChange: (string) => void
  value: string
}) => {
  let operators = []
  if (field.type === CustomFieldType.DATE) {
    operators = [
      { text: 'after', value: MemberListFilterByOperator.GTE },
      { text: 'before', value: MemberListFilterByOperator.LTE },
      { text: 'on', value: MemberListFilterByOperator.EQUALS },
    ]
  } else {
    operators = [
      { text: 'is', value: MemberListFilterByOperator.EQUALS },
      { text: 'is not', value: MemberListFilterByOperator.NOT },
    ]
  }

  return (
    <div className="flex-shrink-0">
      <Dropdown>
        <Dropdown.Button>
          {operators?.find(operator => operator.value === value)?.text}
        </Dropdown.Button>
        <Dropdown.Items>
          {operators.map(operator => (
            <Dropdown.Item
              onClick={() => onChange(operator.value)}
              key={operator.value}
            >
              {operator.text}
            </Dropdown.Item>
          ))}
        </Dropdown.Items>
      </Dropdown>
    </div>
  )
}
